// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reg-auth-forgot__tabs[data-v-67f3acaa] .tabs__buttons{width:100%}.reg-auth-forgot__tabs[data-v-67f3acaa] .tabs__item{width:50%;margin-right:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
